module.exports = __webpack_public_path__ + "img/viclou.d314647d.jpg";